import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { hostedAppService } from '../../services/api';
import { INK, MUTED, RULE, Section } from '../analytics/analyticsUi';

// A customer's own app: what it is called and where to open it. Nothing about the server it runs on.
const YourAppCard = () => {
  const [apps, setApps] = useState(null);

  useEffect(() => {
    hostedAppService.mine()
      .then((response) => setApps(response.data?.apps || []))
      .catch(() => setApps([]));
  }, []);

  // Nothing to show while loading, and nothing at all for a customer without an app
  if (!apps?.length) return null;

  return (
    <Section title={apps.length === 1 ? 'Your app' : 'Your apps'}>
      <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
        {apps.map((app, index) => (
          <Box
            component="li"
            key={app.id}
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1.5,
              py: 1.5,
              borderTop: index ? `1px solid ${RULE}` : 'none'
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{ color: INK, fontWeight: 600 }} noWrap>{app.clientName}</Typography>
              <Typography variant="body2" sx={{ color: MUTED }} noWrap>{app.domain}</Typography>
            </Box>
            <Button
              variant="outlined"
              size="small"
              endIcon={<OpenInNewIcon />}
              href={`https://${app.domain}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ textTransform: 'none', flexShrink: 0 }}
            >
              Open
            </Button>
          </Box>
        ))}
      </Box>
    </Section>
  );
};

export default YourAppCard;
